module.exports = __webpack_public_path__ + "fa95cf7a8b6b16857b2e4cda0429ba3b.jpg";